import React, { useContext } from "react";
import { Context } from "../../../Context";
import { SignatureRequestDetailView, SignatureRequestDetailViewVolume } from "../../views/index";
import {
  SignatureRequestService,
  SignerService,
  UserDocService,
  LocalStorageService,
  SignatureTypesService,
  UserDocSuppService,
  BovedaApi,
  UserService,
  ClientService
} from "../../../services/index";
import { SignatureRequestValidator } from "../../../validators/index";
import { useTranslation } from "react-i18next";
import initialState from "../../../utils/initialState";
import moment from "moment";
import "moment/locale/es";
import hash from "object-hash";

class SignatureRequestDetailAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSignature: null,
      imageWidth: 450,
      pdfWidth: 170,
      userRequestingSingError: false,
      userPfxError: false,
      signatureRequest: {},
      signRequestPDF: "",
      signRequestPDFURL: "",
      expirationDate: "",
      comments: "",
      commentsDelete: "",
      signatureImgeData: {},
      signRequest: {},
      userCanSign: "",
      signStatusName: "",
      signStatusColor: "",
      isSignRequestPending: false,
      isSignRequestReject: false,
      userCanEditExpirationDate: false,
      userCanCancelSignRequest: false,
      signRequestHasAlmostASign: null,
      limitExpirationDate: "",
      routeIsFromIndex: false,
      currentType: null,
      signRequestIsExpired: false,
      userCanResendInformation: false,
      dataItem: {},
      newSign: true,
      imageData: {},
      authorizerCanSign: false,
      visibleAccept: false,
      visibleReject: false,
      visibleExpirationDate: false,
      visibleDialogResendSignatureRequest: false,
      visibleDialogReactivateSignatureRequest: false,
      visibleDialogDeleteRequest: false,
      message: "",
      passwordKey: "",
      selectedFileKey: null,
      selectedFileCer: null,
      selectedFileKeyName: "",
      selectedFileCerName: "",
      // subtitle: 'Información de la solicitud de Firma',
      userHasPfx: false,
      userPfx: "",
      userRequestingSign: "",
      signRequestSigners: [],
      currentUserName: "",
      signatureImg: null,
      ineFrontImg: null,
      ineBackImg: null,

      errorFileKey: false,
      errorFileCer: false,
      errorPassword: false,
      passwordValid: true,
      textAreaValid: false,
      errorTextArea: false,

      showNotification: false,
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,

      tokenUserNames: "",
      tokenUserLastnames: "",

      skip: 0,
      take: 6,
      date: new Date(),

      signatureTypes: {},
      isShowAutorizationModal: false,
      imgLoading: true,
      isWarnign: false,
      requireSignSupport: false,
      password: "",
      passwordReliable: "",

      changePasswordShowPasswordIcon:
        "change-password-input-show-password-icon-desactive",
      changePasswordShowPasswordConfirmIcon:
        "change-password-input-show-password-icon-desactive",
      errorForm: false,
      errorMessage: "",

      emailUser: "",
      allSignatures: [],
      showCompletedRequesting: false,
      showLoadingRequesting: false,
      idPrecharge: null,
      idVault: 0,
      watermarkUrl: "",
      showBtnSend: true,
      showBtnClassify: true,
      stampVolume: "",
      showReasonCancellation: false,
      cancellationReason: '',
      dateLimitTypeDate: '',
      signerRequiredUploadINE: false,
      showIconProofOflife: false,
      showIconSignaturesMultiple: false
    };
    this.toggleDialogAccept = this.toggleDialogAccept.bind(this);
    this.toggleDialogReject = this.toggleDialogReject.bind(this);
    this.onDeleteDataAccept = this.onDeleteDataAccept.bind(this);
    this.onDeleteDataReject = this.onDeleteDataReject.bind(this);
  }

  token = {};
  timezone = "";
  url = process.env.REACT_APP_MIFIRMA_API;
  signatureRequestService = new SignatureRequestService(this.url);
  signerService = new SignerService(this.url);
  signatureTypesService = new SignatureTypesService(this.url);
  userDocSuppService = new UserDocSuppService(this.url);
  userDocService = new UserDocService(this.url);
  localStorageService = new LocalStorageService();
  bovedaService = new BovedaApi(this.url);
  userService = new UserService(this.url);
  clientService = new ClientService(this.url)
  validator = SignatureRequestValidator(this.props.t);
  baseSign = false
  currentUser = {}

  async componentDidMount() {
    this.setState({ loading: true });
    let requestId = this.props.match.params.id;
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.timezone = this.localStorageService.getLocalStorageItem("timezone");
    let userInfo =
      this.localStorageService.getLocalStorageItem("user").userMetaData;
    let tokenUserName = `${userInfo.userA3Cloud.firstName} ${userInfo.userA3Cloud.firstLastName} ${userInfo.userA3Cloud.secondLastName}`;
    let tokenUserNames = `${userInfo.userA3Cloud.firstName}`;
    let emailUser = `${userInfo.userA3Cloud.email}`;
    let tokenUserLastnames = `${userInfo.userA3Cloud.firstLastName} ${userInfo.userA3Cloud.secondLastName}`;
    let signatureResponse = await this.signatureRequestService.getOldSignatureRequestById(
      requestId,
      this.token
    );
    if (signatureResponse.statusCode === Number(process.env.REACT_APP_STATUS_CODE_NOT_ACCES)) {
      this.setState({ message: signatureResponse.message })
      this.toggleErrorForbidden(true, this.state.message)
      return false
    }
    let signatureRequest = signatureResponse.data
    let signatureTypes =
      initialState["signatureTypesService.getSignatureTypes"];

    let preferences = await this.clientService.getClientPreferences(this.token, this.timezone);

    //Validate signature base
    let signatureBaseCreatedAfterWorkflow = (signatureRequest.userAutographySign && signatureRequest.userAutographySign.status) ? true : false
    let sigantureBaseIsApproved = (signatureBaseCreatedAfterWorkflow && signatureRequest.userAutographySign && signatureRequest.userAutographySign.status && signatureRequest.userAutographySign.status === process.env.REACT_APP_SIGNATURE_BASE_STATUS_APPROVED) ? true : false
    let signatureBaseCanUse = (!signatureBaseCreatedAfterWorkflow || (signatureBaseCreatedAfterWorkflow && sigantureBaseIsApproved)) ? true : false
    if (signatureRequest.autographySign && userInfo.userMifirma.clientId === signatureRequest.signRequest.user.clientId && signatureBaseCanUse) {
      preferences.data.map((preference) => {
        if (preference.preferenceName === process.env.REACT_APP_PREFERENCE_BASE_SIGN && signatureRequest.signRequest.signatureTypeId === Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA)) {
          this.baseSign = preference.booleanValue
        }
      })
    }
    let watermarkGovo = preferences.data.find(item => item.preferenceName === process.env.REACT_APP_PREFERENCE_WATERMARK && item.booleanValue)

    if (watermarkGovo) this.setState({ watermarkUrl: watermarkGovo.configRule.urlDesktop })

    if (!signatureTypes) {
      signatureTypes = await this.signatureTypesService.getSignatureTypes(
        this.token
      );
      initialState["signatureTypesService.getSignatureTypes"] = signatureTypes;
    }

    // Validar su eliminacion...
    let showBtnSend = false
    let showBtnClassify = false

    //Verify if user require tu opload dientity document and is validated
    let signerFound = signatureRequest.signersList.find(signer => signer.email === emailUser)
    let signerRequiredUploadINE = (signerFound && signerFound.identityDocument && !signerFound.identityDocumentValidated) ? true : false

    //If user require upload identity send to view to upload document
    if (signerRequiredUploadINE) {
      this.setState({ loading: false });
      let messageError = this.props.t("signatureRequestDetailView2.error.require.identity.document")
      this.setState({ message: messageError });
      await this.handleWarning(true);
      setTimeout(async () => {
        await this.handleWarning(false);
        this.props.history.push(`/upload-identity-document/${signatureRequest.signRequest.id}`)
        return
      }, 5000)
    }

    try {
      this.setState({ signatureTypes });
      if (signatureRequest.userRequestingSing) {
        let userRequesting = `${signatureRequest.userRequestingSing.firstName} ${signatureRequest.userRequestingSing.firstLastName} ${signatureRequest.userRequestingSing.secondLastName}`;
        moment.locale("es");
        let dateStart = signatureRequest.signRequest.expirationDate;
        let yearStartContract = dateStart.split("/")[2];
        let monthStartContract = dateStart.split("/")[1];
        let dayStartContract = dateStart.split("/")[0];
        let dateStartLimit = signatureRequest.signRequest.limitExpirationDate;
        let yearStartContractL = dateStartLimit.split("/")[2];
        let monthStartContractL = dateStartLimit.split("/")[1];
        let dayStartContractL = dateStartLimit.split("/")[0];
        let showIconProofOflife = false

        signatureRequest.signersList = signatureRequest.signersList.map(
          (request) => {
            if (request.signedDate !== null) {
              moment.locale("es");
              let signedDate = new Date(request.signedDate);
              let dataStartContract = moment(signedDate).format("DD/MMMM/YYYY");
              let yearStartContract = dataStartContract.split("/")[2];
              let monthStartContract = dataStartContract.split("/")[1];
              let dayStartContract = dataStartContract.split("/")[0];
              let dateStartComplete =
                dayStartContract +
                "/" +
                monthStartContract +
                "/" +
                yearStartContract;
              request.signedDate = dateStartComplete;
            } else {
              request.signedDate = "";
            }

            if (emailUser === request.email && request.proofOfLife) showIconProofOflife = true
            return request
          })

        let [day, month, year] = dateStart.split("/");

        let showReasonCancellation = (signatureRequest && signatureRequest.signRequest && signatureRequest.signRequest.signRequestStatus && signatureRequest.signRequest.signRequestStatus.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_CANCEL)) ? true : false
        let cancellationReason = (signatureRequest && signatureRequest.signRequest && signatureRequest.signRequest.cancellationReason) ? signatureRequest.signRequest.cancellationReason : ''
        let dateLimitTypeDate = (signatureRequest && signatureRequest.signRequest && signatureRequest.signRequest.dateLimitTypeDate) ? signatureRequest.signRequest.dateLimitTypeDate : ''
        let showIconSignaturesMultiple = (signatureRequest && signatureRequest.inbox && signatureRequest.inbox.solicitudeHasMultipleSignatures) ? true : false

        this.setState({
          signatureRequest,
          requireSignSupport: signatureRequest?.signRequest?.requireSignSupport,
          authorizerCanSign: signatureRequest.authorizerCanSign,
          signRequest: signatureRequest.signRequest,
          signRequestPDF: signatureRequest.documentPDF,
          signRequestPDFURL: signatureRequest.documentPath,
          expirationDate:
            dayStartContract +
            "/" +
            moment(monthStartContract).format("MMMM") +
            "/" +
            yearStartContract,
          date:
            new Date(+year, +month - 1, +day) > new Date()
              ? new Date(+year, +month - 1, +day)
              : new Date(),
          comments: signatureRequest.signRequest.comments,
          signRequestId: requestId,
          userCanSign: signatureRequest.userCanSign,
          userCanEditExpirationDate: signatureRequest.userCanEditExpirationDate,
          userCanCancelSignRequest: signatureRequest.userCanCancelSignRequest && userInfo.userMifirma.userType.id !== 3,
          limitExpirationDate:
            dayStartContractL +
            "/" +
            moment(monthStartContractL).format("MMMM") +
            "/" +
            yearStartContractL,
          userRequestingSign: userRequesting,
          signRequestSigners: signatureRequest.signersList,
          servicesInSignsRequest: signatureRequest.servicesInSignsRequest,
          currentUserName: tokenUserName,
          tokenUserNames,
          tokenUserLastnames,
          signRequestIsExpired: signatureRequest.signRequestIsExpired,
          userCanResendInformation: signatureRequest.userCanResendInformation,
          signRequestHasAlmostASign:
            signatureRequest?.signRequest?.signRequestHasAlmostASign,
          loading: false,
          signatureTypes,
          emailUser,
          showBtnSend,
          showBtnClassify,
          showReasonCancellation,
          cancellationReason,
          dateLimitTypeDate,
          signerRequiredUploadINE,
          showIconProofOflife,
          showIconSignaturesMultiple
        });
        if (signatureRequest?.signRequest?.requireSignSupport) {
          try {
            let imgs = await this.userDocSuppService.getUserDocSupps(
              this.token
            );
            let { autographySignImg, ineFrontImg, ineBackImg } = imgs;
            if (autographySignImg && ineFrontImg && ineBackImg) {
              this.setState({
                signatureImg: "data:image/png;base64," + autographySignImg,
                ineFrontImg: "data:image/png;base64," + ineFrontImg,
                ineBackImg: "data:image/png;base64," + ineBackImg,
                imgLoading: false,
              });
            } else this.warningUserDontHaveIne(true);
          } catch (error) {
            this.setState({
              imgLoading: false,
            });
            this.warningUserDontHaveIne(true);
          }
        }

        let signStatusName =
          signatureRequest.signRequest.signRequestStatus.name;
        this.setState({ signStatusName });

        if (
          signatureRequest.signRequest.signRequestStatus.id ===
          Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING)
        ) {
          // pending
          this.setState({
            signStatusColor: "status-pending",
            isSignRequestPending: true,
          });
        } else if (
          signatureRequest.signRequest.signRequestStatus.id ===
          Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_REJECT)
        ) {
          // reject
          this.setState({
            signStatusColor: "status-reject",
            isSignRequestReject: true,
          });
        } else if (
          signatureRequest.signRequest.signRequestStatus.id ===
          Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET)
        ) {
          // complet
          this.setState({ signStatusColor: "status-complete" });
        } else if (
          signatureRequest.signRequest.signRequestStatus.id ===
          Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_CANCEL)
        ) {
          // Cancel
          this.setState({ signStatusColor: "status-cancel" });
        }

        if (this.props.match.params) {
          if (this.props.match.params.route === "index") {
            this.setState({ routeIsFromIndex: true });
          }
        }
      } else
        this.setState(
          {
            userRequestingSingError: true,
          },
          () => setTimeout(() => this.props.history.goBack(), 5000)
        );
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
      return;
    }
  }

  /* ============= START Dialog ================ */
  /**
   * @author Lucia Alvarado
   * @description Show dialog confirm
   * @param {Object} dataItem
   * @memberof SignatureRequestDetailAction
   */
  toggleDialogAccept() {
    this.setState({
      visibleAccept: !this.state.visibleAccept,
      visibleReject: false,
    });
  }

  /**
   * @author Lucia Alvarado
   * @description Show dialog reject
   * @param {Object} dataItem
   * @memberof SignatureRequestDetailAction
   */
  toggleDialogReject() {
    this.setState({
      visibleReject: !this.state.visibleReject,
      visibleAccept: false,
    });
  }

  assignStampVolume = (stamp) => {
    this.setState({ stampVolume: stamp })
  }
  /**
   * @author Leonel Contreras
   * @description Close/Open the modal
   */
  onCloseOpenModal = () =>
    this.setState({ showNotification: !this.state.showNotification });

  /**
   * @author Leonel Contreras
   * @description Close the modal after some time
   */
  handleMessage = () => {
    setTimeout(() => {
      this.onCloseOpenModal();
    }, 15000);
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @memberof SignatureRequestAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the confirmed sign dialog modal and redirecto to home
   * @memberof SignatureRequestAction
   */
  toggleCompletedRequesting = (value, redirect) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
          if (redirect === true) this.props.history.push("/");
        }, 3500);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the confirmed sign dialog modal and redirecto to home
   * @memberof SignatureRequestAction
   */
  toggleCompletedRequestingLimitDate = (value) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
        }, 3500);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the error dialog modal
   * @updatedDate 11-10-2021
   * @memberof SignatureRequestAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
          if (this.state.visibleAccept === false)
            this.setState({ visibleAccept: true });
        }, 6000);
        if (this.state.visibleAccept === false && value === false)
          this.setState({ visibleAccept: true });
      }
    );
  };

  /**
   * @author Pedro Antonio
   * @description Method to show the error dialog modal
   * @updatedDate 11-10-2021
   * @memberof SignatureRequestAction
   */
  toggleErrorRequestingLimitDate = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 6000);
      }
    );
  };

  toggleErrorForbidden = (value, message) => {
    this.setState(
      {
        errorMessage: message,
        showErrorRequesting: value,
        loading: false
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
          this.props.history.push("/")
        }, 3000);
      }
    );
  }

  /**
   * @author Alan Aguilar
   * @description Method to show the edit expiration date dialog
   * @date 26-10-2020
   * @memberof SignatureRequestAction
   */
  toggleEditExpirationDate = () => {
    this.setState({ visibleExpirationDate: !this.state.visibleExpirationDate });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the resend signature request dialog
   * @updatedDate 03-06-2021
   * @memberof SignatureRequestAction
   */
  toggleDialogResendSignatureRequest = () => {
    this.setState({
      visibleDialogResendSignatureRequest:
        !this.state.visibleDialogResendSignatureRequest,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the reactivation signature request dialog
   * @updatedDate 03-06-2021
   * @memberof SignatureRequestAction
   */
  toggleDialogReactivateSignatureRequest = () => {
    this.setState({
      visibleDialogReactivateSignatureRequest:
        !this.state.visibleDialogReactivateSignatureRequest,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to show and close the Dialog Delete
   * @updatedDate 08-07-2021
   * @memberof SignatureRequestAction
   */
  toggleDialogDeleteRequest = () => {
    this.setState({
      visibleDialogDeleteRequest: !this.state.visibleDialogDeleteRequest,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to update a signRequest expiration date
   * @updatedDate 20-10-2021
   * @memberof SignatureRequestAction
   */
  onUpdateExpirationDate = async (dataItem) => {
    moment.locale("es");
    try {
      await this.toggleLoadingRequesting(true);
      await this.toggleEditExpirationDate();
      let { expirationDate } = dataItem;
      let { id } = this.state.signRequest;
      let newExpirationDate =
        await this.signatureRequestService.updateSignRequestExpirationDate(
          id,
          expirationDate,
          this.token
        );
      if (
        Number(newExpirationDate.statusCode) !== 200 ||
        !newExpirationDate.data
      ) {
        throw new Error("No se puedo actualizar la fecha de expiración");
      }

      let newDate = new Date(
        newExpirationDate.data.newExpirationDate.expirationDate
      );
      let newDateFormated = moment(newDate).format("DD/MMMM/YYYY");
      let yearNewDate = newDateFormated.split("/")[2];
      let monthNewDate = newDateFormated.split("/")[1];
      let dayNewDate = newDateFormated.split("/")[0];
      let updatedDate = dayNewDate + "/" + monthNewDate + "/" + yearNewDate;
      this.setState({ expirationDate: updatedDate });

      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequestingLimitDate(true);
      return true;
    } catch (error) {
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequestingLimitDate(true);
      return false;
    }
  };
  /**
   * @author Alan Aguilar
   * @description Method to change page of grid
   */
  onPageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method Delete the ConfirmationSign dato from the state
   * @param {Event} event
   * @memberof SignatureRequestDetailAction
   */
  onDeleteDataAccept() {
    this.setState({
      visibleAccept: false,
      dataItem: {},
      selectedFileKey: null,
      selectedFileCer: null,
    });
    this.clearErrors();
  }

  /**
   * @author Lucy Alvarado
   * @description Method for hide the Dialog of data reject
   * @param {Event} event
   * @memberof SignatureRequestDetailAction
   */
  onDeleteDataReject() {
    this.setState({
      visibleReject: !this.state.visibleReject,
    });
  }

  /* ============= END Dialog ================ */

  /**
   * @author Alan Aguilar
   * @description Method to get the file
   * @param {Event} event
   * @memberof SignatureRequestDetailAction
   */
  handleFileKey = (e) => {
    if (e.target.files.length > 0) {
      let filename = e.target.files[0].name;
      let filenameArray = filename.split(".");
      let extension = filenameArray[filenameArray.length - 1];

      if (extension === "key" || extension === "pem") {
        this.setState({
          selectedFileKey: e.target.files[0],
          errorFileKey: false,
          selectedFileKeyName: filename,
        });
      } else {
        this.setState({
          selectedFileKey: null,
          errorFileKey: true,
          selectedFileKeyName: `${this.props.t(
            "signatureRequestDetailAction2.noUploadFile"
          )}`,
        });
        return false;
      }
    } else {
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to get the file
   * @param {Event} event
   * @memberof SignatureRequestDetailAction
   */
  handleFileCer = (e) => {
    if (e.target.files.length > 0) {
      let filename = e.target.files[0].name;
      let filenameArray = filename.split(".");
      let extension = filenameArray[filenameArray.length - 1];

      if (extension === "cer" || extension === "pem") {
        this.setState({
          selectedFileCer: e.target.files[0],
          errorFileCer: false,
          selectedFileCerName: filename,
        });
      } else {
        this.setState({
          selectedFileCer: null,
          errorFileCer: true,
          selectedFileCerName: `${this.props.t(
            "signatureRequestDetailAction2.noUploadFile"
          )}`,
        });
        return false;
      }
    } else {
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method for show or hide the form with the switch
   * @param {Event} event
   * @memberof SignatureRequestDetailAction
   */
  handleSwitch = () => {
    this.setState({ newSign: !this.state.newSign });
  };

  /**
   * @author Alan Aguilar
   * @description Method for delete the error from the state
   * @param {Event} event
   * @memberof SignatureRequestDetailAction
   */
  clearErrors = () => {
    this.setState({
      errorFileKey: false,
      errorFileCer: false,
      errorPassword: false,
      errorTextArea: false,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to clear and hide dialog
   * @memberof SignatureRequestAction
   */
  cancel = () => {
    this.setState({
      disableUserButton: true,
      errorTextArea: false,
    });
    this.clearErrors();
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for submit the comments to the state
   * @updatedDate 08-07-2021
   * @memberof SignatureReceivePanelAction
   */
  handleCommentsDelete = async (event) => {
    this.setState({
      commentsDelete: event.target.value,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to move scroll
   * @memberof SignatureRequestAction
   */
  scrollWindow = () => {
    window.scrollTo(0, 0);
  };

  authorize = async () => {
    this.setIsShowAutorizationModal();
    await this.toggleLoadingRequesting(true);
    let authorizeData = new FormData();
    authorizeData.append(
      "hash",
      hash({ hash: Math.random().toString(36).substring(7) })
    );
    authorizeData.append("signRequestId", this.state.signRequest.id);
    authorizeData.append(
      "signatureTypeId",
      this.state.signRequest.signatureTypeId
    );
    let signConfirm = await this.signerService.createConfirmSign(
      authorizeData,
      this.token
    );
    if (signConfirm.statusCode === 200) {
      initialState["planService.getUserContractAndPlan"] = null;
      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequesting(true, true);
      this.setState({ showNotification: true });
    } else if (signConfirm.statusCode === -1) {
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      this.setState({ showNotification: true });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Call service to resend the information of the sign request completed
   * @updatedDate 03-06-2021
   * @memberof SignatureRequestAction
   */
  onResendSignatureRequest = async () => {
    try {
      await this.toggleLoadingRequesting(true);
      let result =
        await this.signatureRequestService.resendSignRequestInformation(
          this.state.signRequest.id,
          this.token
        );
      if (result.statusCode === 200) {
        await this.toggleLoadingRequesting(false);
        await this.toggleCompletedRequesting(true, false);
        this.setState({ visibleDialogResendSignatureRequest: false });
      } else {
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        return false;
      }
    } catch (error) {
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Call service to reactivate a the sign request when rejected
   * @updatedDate 03-06-2021
   * @memberof SignatureRequestAction
   */
  onReactivateSignatureRequest = async () => {
    try {
      await this.toggleLoadingRequesting(true);
      let result =
        await this.signatureRequestService.reactivationSignRequestRejected(
          this.state.signRequest.id,
          this.token
        );
      if (result.statusCode === 200) {
        await this.toggleLoadingRequesting(false);
        await this.toggleCompletedRequesting(true, false);
        this.setState({ visibleDialogReactivateSignatureRequest: false });
        window.location.reload();
      } else {
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        return false;
      }
    } catch (error) {
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Call service to delete a the sign request
   * @updatedDate 08-07-2021
   * @memberof SignatureRequestAction
   */
  deleteSignRequest = async () => {
    let { commentsDelete, signRequest } = this.state;
    let statusCode = 0;

    try {
      await this.toggleLoadingRequesting(true);
      let signRequestDetele =
        await this.signatureRequestService.deleteSignRequestsById(
          signRequest.id,
          commentsDelete,
          this.token
        );
      if (signRequestDetele.statusCode !== 200) {
        statusCode = signRequestDetele.statusCode;
        throw new Error();
      }

      this.setState({ visibleDialogDeleteRequest: false });
      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequesting(true, true);
      return true;
    } catch (error) {
      switch (statusCode) {
        case -2:
          this.setState({
            message: this.props.t(
              "signatureRequestDetailAction2.errorMessageOnlyUserSenderCanDelete"
            ),
          });
          break;
        case -3:
          this.setState({
            message: this.props.t(
              "signatureRequestDetailAction2.errorMessageOnlyDeleteWithAlmostOneSign"
            ),
          });
          break;
        default:
          this.setState({
            message: this.props.t(
              "signatureRequestDetailAction2.errorMessageDefault"
            ),
          });
          break;
      }
      this.setState({ visibleDialogDeleteRequest: false });
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to hide and show the password icon and text in Change Password form
   * @date 15-12-2020
   * @memberof AuthService
   */
  onHandleShowPassword = () => {
    let { changePasswordShowPasswordIcon } = this.state;
    let inputPassword = document.querySelector("#password");

    if (
      changePasswordShowPasswordIcon ===
      "change-password-input-show-password-icon-desactive" &&
      inputPassword.type === "password"
    ) {
      inputPassword.type = "text";
      this.setState({
        changePasswordShowPasswordIcon:
          "change-password-input-show-password-icon-active",
      });
    } else {
      inputPassword.type = "password";
      this.setState({
        changePasswordShowPasswordIcon:
          "change-password-input-show-password-icon-desactive",
      });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for capture the information in all inputs
   * @date 15-12-2020
   * @param {Object} e
   * @memberof AuthService
   */
  onHandleGeneralChange = (e) => {
    this.setState({
      ...this.state,
      [e.target.id]: e.target.value,
    });
  };

  /**
   * @param {string} nip
   * @param {React.Dispatch<React.SetStateAction<string>>} setNip
   * @returns {Promise<boolean>}
   * @memberof SignatureRequestDetailAction
   */
  validateNip = async (nip, setNip) => {
    let validatedNip
    if (this.baseSign && !this.currentUser.proofOfLife) {
      try {
        let nipValidated = await this.userDocService.verifyNip(nip, this.token)
        if (nipValidated.isEqual === false) {
          validatedNip = nipValidated.isEqual
          setNip("")
          this.setState({
            message: this.props.t(`signatureRequestDetailAction2.errorNip`),
          });
          await this.toggleLoadingRequesting(false);
          await this.toggleErrorRequesting(true);
        } else {
          validatedNip = true
        }
      } catch (e) {
        setNip("")
        validatedNip = false
        this.setState({
          message: this.props.t(`signatureRequestDetailAction2.errorNip`),
        });
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
      }
    }
    return validatedNip
  }

  /**
   * @author Lucia Alvarado
   * @description Handle the submit event to accept sign
   * @updatedDate 01-04-2022
   * @param {string} nip
   * @param {React.Dispatch<boolean>} setNip
   * @param {string} stampTime
   * @param {Blob} [bufferVideo]
   * @param {Blob} [bufferImage]
   * @memberof SignatureRequestDetailAction
   */
  onSubmit = async (nip, setNip, stampTime, bufferVideo, bufferImage) => {
    try {
      await this.toggleLoadingRequesting(true);
      await this.clearErrors();
      this.setState({ visibleAccept: false });

      if (this.state.userCanSign === false) return false;
      if (this.state.errorFileKey === true || this.state.errorFileCer === true) return false;

      if (this.baseSign && this.state.allSignatures.find((i) => !!i.fileSignImage) && !this.currentUser.proofOfLife) {
        let newNip = await this.userDocService.verifyNip(nip, this.token)
        if (newNip.isEqual === false) {
          setNip("")
          this.setState({
            message: this.props.t(`signatureRequestDetailAction2.errorNip`),
          });
          await this.toggleLoadingRequesting(false);
          await this.toggleErrorRequesting(true);
          return false
        }
      }

      // 1.- Peticion POST para aceptar la solicitud de firma /signer-confirm-sign
      let signRequestDocumentData = new FormData();
      signRequestDocumentData.append(
        "signRequestId",
        this.state.signRequest.id
      );
      signRequestDocumentData.append(
        "signatureTypeId",
        this.state.signRequest.signatureTypeId
      );
      signRequestDocumentData.append("signatureStampTime", stampTime);

      if (this.currentUser.proofOfLife) {
        signRequestDocumentData.append("bufferVideo", bufferVideo)
        signRequestDocumentData.append("bufferImage", bufferImage)
      }

      if (this.state.allSignatures.find((i) => !!i.fileSignImage)) {
        signRequestDocumentData.append(
          "signatures",
          JSON.stringify(
            this.state.allSignatures.map((i) => ({
              x: i.x,
              y: i.y,
              width: i.width,
              height: i.height,
              page: i.page,
              isMobile: i.isMobile,
              fileName: i.fileName,
            }))
          )
        );
        this.state.allSignatures.forEach((i) => {
          signRequestDocumentData.append(i.fileName, i.fileSignImage);
        });
      }
      else {
        if (this.state.passwordKey)
          signRequestDocumentData.append("passwordKey", this.state.passwordKey);
        if (this.state.passwordReliable)
          signRequestDocumentData.append(
            "passwordReliable",
            this.state.passwordReliable
          );

        signRequestDocumentData.append("fileKEY", this.state.selectedFileKey);
        signRequestDocumentData.append("fileCER", this.state.selectedFileCer);
      }

      if (!!this.state.signatureImgeData && !this.state.allSignatures.find((i) => !!i.fileSignImage)) {
        signRequestDocumentData.append("imageWidth", this.state.imageWidth);
        if (this.state.pdfWidth)
          signRequestDocumentData.append("pdfWidth", this.state.pdfWidth);
        await fetch(this.state.imgSignature)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], "signature.png");
            signRequestDocumentData.append("sign1", file);
          });

        let { signatureImgeData } = this.state;
        if (
          signatureImgeData.x &&
          signatureImgeData.y &&
          signatureImgeData.width &&
          signatureImgeData.height &&
          signatureImgeData.page
        ) {
          signRequestDocumentData.append(
            "signatures",
            JSON.stringify(
              this.state.allSignatures.map((i) => ({
                x: signatureImgeData.x,
                y: signatureImgeData.y,
                width: signatureImgeData.width * 1.15,
                height: signatureImgeData.height * 1.15,
                page: signatureImgeData.page,
                isMobile: true,
                fileName: "sign1",
              }))
            )
          );
        }
      }

      // for (var pair of signRequestDocumentData.entries()) {
      //   console.log(pair[0] + ', ' + pair[1]);
      // }
      let signConfirm = await this.signerService.createConfirmSign(
        signRequestDocumentData,
        this.token
      );

      if (signConfirm.statusCode === 200) {
        initialState["planService.getUserContractAndPlan"] = null;
        await this.toggleLoadingRequesting(false);
        await this.toggleCompletedRequesting(true, true);
        this.scrollWindow();
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === 420 && (signConfirm.data && signConfirm.data.signing)) {
        this.setState({
          message: `${this.props.t(
            "signRequestDetail.isSigningPt1"
          )} ${signConfirm.data.emailSigner} ${this.props.t(
            "signRequestDetail.isSigningPt2"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === 420) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorValidateInformationProvided"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === 403) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorUserDoesNotHaveAccess"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -2) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorUserCreateSignRequestDontHaveCredits"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -3) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorSequentialSignerNotTurnOrAlreadySign"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -4) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorWithAprovationPendingAuthorizers"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -5) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorWithAprovationSequentialPendingAuthorizers"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -6) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorWithAprovationSequentialNotTurn"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -11) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorCertificateESignatureIsExpired"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -12) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorCertificateRFCNotValid"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -13) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorSATServiceNotAvailable"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -14) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorCertificateSATServiceResponse"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -15) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorValidationFilesESignature"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -15) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorValidationFilesESignature"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -16) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorRFCOfUserNotFoundOrInvalid"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -22) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorCertificateAdvanceSignatureIsExpired"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -23) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorValidationFilesAdvanceSignature"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -30) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorOnServicesPSC"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -31) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorINEOrAuthorizerSignatureNotFound"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === -32) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorINEOrAuthorizerSignatureExpired"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      } else if (signConfirm.statusCode === 450 || signConfirm.statusCode === 452) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errors.facerecognititon.face.no.match"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
        setTimeout(() => {
          this.props.history.push("/")
        }, 4000)
      } else if (signConfirm.statusCode === 490) {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errors.facerecognititon.canceled"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
        setTimeout(() => {
          this.props.history.push("/")
        }, 4000)
      } else {
        this.setState({
          message: `${this.props.t(
            "signatureRequestDetailAction2.errorSignatureReliable"
          )}`,
        });
        await this.toggleLoadingRequesting(false);
        await this.toggleErrorRequesting(true);
        this.setState({ showNotification: true });
      }
    } catch (error) {
      this.setState({
        message: `${this.props.t(
          "signatureRequestDetailAction2.errorDefaultSignerConfirm"
        )}`,
      });
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      return false;
    }
  };

  /**
   * @author Lucia Alvarado
   * @description Handle the submit event to reject sign
   * @param {Event} event
   * @memberof SignatureRequestDetailAction
   */
  onSubmitReject = async (dataItem) => {
    try {
      await this.clearErrors();
      this.cancel();
      // 2.- Peticion POST para rechazar solicitud de firma /signer-reject-sign

      if (dataItem.comments.trim() <= 0) {
        this.setState({ errorTextArea: true });
        return false;
      } else {
        this.setState({ errorTextArea: false, visibleReject: false });
        this.clearErrors();
        this.cancel();
        await this.toggleLoadingRequesting(true);
        let signReject = await this.signerService.createRejectSign(
          this.state.signRequest.id,
          this.state.signRequest.signRequestStatus.id,
          dataItem.comments,
          this.token
        );
        if (signReject.statusCode === 200) {
          this.setState({ visibleReject: false, showLoadingRequesting: false, showCompletedRequesting: true });
          setTimeout(() => {
            this.setState({ showCompletedRequesting: false, showNotification: true })
            this.props.history.push("/");
          }, 3000)

        } else if (signReject.statusCode === -1) {
          this.setState({ visibleReject: false, showLoadingRequesting: false, showCompletedRequesting: true });
          setTimeout(() => {
            this.setState({ showErrorRequesting: false, showNotification: true })
            this.props.history.push("/");
          }, 3000)
          this.setState({ showNotification: true });
        }
      }
    } catch (error) {
      this.setState({
        message: `${this.props.t(
          "signatureRequestDetailAction2.errorDefaultMessage"
        )}`,
      });
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      return false;
    }
  };

  warningUserDontHaveIne = (isWarnign = false) => {
    let data = {
      message: `${this.props.t(
        "signatureRequestDetailAction2.errorINEOrAuthorizerSignatureNotFound"
      )}`,
    };
    if (isWarnign) {
      data.isWarnign = isWarnign;
    } else data.showErrorRequesting = true;
    this.setState(data);
  };

  handleWarning = () => this.setState({ isWarnign: !this.state.isWarnign });

  setPassword = (passwordKey) => this.setState({ passwordKey });
  setIsShowAutorizationModal = () =>
    this.setState({
      isShowAutorizationModal: !this.state.isShowAutorizationModal,
    });

  /**
   * @author Alan Aguilar
   * @updatedDate 03-11-2022
   * @description Handler to show an error if the function getStampTimeAndTimezone() fails
   * @memberof SignatureRequestDetailAction
   */
  onErrorTimeStamp = async () => {
    this.setState({
      message: `${this.props.t(
        "signatureRequestDetailAction2.errorStampTimeFails"
      )}`,
    });
    this.toggleErrorRequesting(true);
    return false;
  };

  // sendToDigitalVault = async (signRequestId) => {
  //   this.setState({ showLoadingRequesting: true });
  //   let response = await this.bovedaService.uploadBovedaDocument(
  //     signRequestId,
  //     this.token
  //   );
  //   if (response?.code === 200) {
  //     this.setState({
  //       showLoadingRequesting: false,
  //       showCompletedRequesting: true,
  //       idPrecharge: response.idPrecarga,
  //     });
  //     setTimeout(() => {
  //       this.setState({ showCompletedRequesting: false });
  //     }, 3000);
  //   } else {
  //     this.setState({
  //       showLoadingRequesting: false,
  //       showErrorRequesting: true,
  //     });
  //     setTimeout(() => {
  //       this.setState({ showErrorRequesting: false });
  //     }, 3000);
  //   }
  // };

  render() {
    // if (true) return (<CalligraphicExercisesReportDetailRequestView />)
    if (this.state.signRequestSigners.find(
      (item) => item.email === this.state.emailUser && item.signerTypeName === "Autorizador"
    ) && this.state.signRequestSigners.find(
      (item) => item.email === this.state.emailUser && item.signerTypeName === "Firmante"
    )) {
      this.currentUser = this.state.signRequestSigners.find(
        (item) => item.email === this.state.emailUser && item.signerTypeName === "Firmante"
      );
      if (this.currentUser) {
        if (this.currentUser.proofOfLife || !this.currentUser.signatureBaseValid) this.baseSign = false
      }
    } else {
      this.currentUser = this.state.signRequestSigners.find(
        (item) => item.email === this.state.emailUser)
      if (this.currentUser) {
        if (this.currentUser.proofOfLife || !this.currentUser.signatureBaseValid) this.baseSign = false
      }
    }
    return (
      (this.state.signatureRequest?.signRequest?.signRequestByVolumeId === null ?
        <SignatureRequestDetailView
          {...this.state}
          validateNip={this.validateNip}
          baseSign={this.baseSign}
          classifyToDigitalVault={this.classifyToDigitalVault}
          // sendToDigitalVault={this.sendToDigitalVault}
          currentUser={this.currentUser}
          setPassword={this.setPassword}
          authorize={this.authorize}
          toggleDialogAccept={this.toggleDialogAccept}
          toggleDialogReject={this.toggleDialogReject}
          toggleEditExpirationDate={this.toggleEditExpirationDate}
          onDeleteDataAccept={this.onDeleteDataAccept}
          onDeleteDataReject={this.onDeleteDataReject}
          setImgSignature={(params) => this.setState(params)}
          onSubmit={this.onSubmit}
          handleSubmit={this.handleSubmit}
          setCurrentType={(val) => this.setState({ currentType: val })}
          onSubmitReject={this.onSubmitReject}
          onPageChange={this.onPageChange}
          onUpdateExpirationDate={this.onUpdateExpirationDate}
          handleFileKey={this.handleFileKey}
          handleFileCer={this.handleFileCer}
          handleSwitch={this.handleSwitch}
          view={this.props.match.params}
          onCloseOpenModal={this.onCloseOpenModal}
          toggleLoadingRequesting={this.toggleLoadingRequesting}
          toggleCompletedRequesting={this.toggleCompletedRequesting}
          toggleErrorRequesting={this.toggleErrorRequesting}
          validator={this.validator}
          setIsShowAutorizationModal={this.setIsShowAutorizationModal}
          scrollWindow={this.scrollWindow}
          setSignatureImgeData={(signatureImgeData) => {
            this.setState({ signatureImgeData }, () => this.onSubmit());
          }}
          toggleDialogResendSignatureRequest={
            this.toggleDialogResendSignatureRequest
          }
          toggleDialogDeleteRequest={this.toggleDialogDeleteRequest}
          deleteSignRequest={this.deleteSignRequest}
          handleCommentsDelete={this.handleCommentsDelete}
          onResendSignatureRequest={this.onResendSignatureRequest}
          toggleDialogReactivateSignatureRequest={
            this.toggleDialogReactivateSignatureRequest
          }
          onReactivateSignatureRequest={this.onReactivateSignatureRequest}
          warningUserDontHaveIne={this.warningUserDontHaveIne}
          handleWarning={this.handleWarning}
          onHandleGeneralChange={this.onHandleGeneralChange}
          onHandleShowPassword={this.onHandleShowPassword}
          setSignatures={(signatures) =>
            this.setState({ allSignatures: signatures })
          }
          onErrorTimeStamp={this.onErrorTimeStamp}
        />
        :
        <SignatureRequestDetailViewVolume
          {...this.state}
          assignStampVolume={this.assignStampVolume}
          classifyToDigitalVault={this.classifyToDigitalVault}
          // sendToDigitalVault={this.sendToDigitalVault}
          currentUser={this.currentUser}
          setPassword={this.setPassword}
          authorize={this.authorize}
          toggleDialogAccept={this.toggleDialogAccept}
          toggleDialogReject={this.toggleDialogReject}
          toggleEditExpirationDate={this.toggleEditExpirationDate}
          onDeleteDataAccept={this.onDeleteDataAccept}
          onDeleteDataReject={this.onDeleteDataReject}
          setImgSignature={(params) => this.setState(params)}
          onSubmit={this.onSubmit}
          handleSubmit={this.handleSubmit}
          setCurrentType={(val) => this.setState({ currentType: val })}
          onSubmitReject={this.onSubmitReject}
          onPageChange={this.onPageChange}
          onUpdateExpirationDate={this.onUpdateExpirationDate}
          handleFileKey={this.handleFileKey}
          handleFileCer={this.handleFileCer}
          handleSwitch={this.handleSwitch}
          view={this.props.match.params}
          onCloseOpenModal={this.onCloseOpenModal}
          toggleLoadingRequesting={this.toggleLoadingRequesting}
          toggleCompletedRequesting={this.toggleCompletedRequesting}
          toggleErrorRequesting={this.toggleErrorRequesting}
          validator={this.validator}
          setIsShowAutorizationModal={this.setIsShowAutorizationModal}
          scrollWindow={this.scrollWindow}
          setSignatureImgeData={(signatureImgeData) => {
            this.setState({ signatureImgeData }, () => this.onSubmit("", "", this.state.stampVolume));
          }}
          toggleDialogResendSignatureRequest={
            this.toggleDialogResendSignatureRequest
          }
          toggleDialogDeleteRequest={this.toggleDialogDeleteRequest}
          deleteSignRequest={this.deleteSignRequest}
          handleCommentsDelete={this.handleCommentsDelete}
          onResendSignatureRequest={this.onResendSignatureRequest}
          toggleDialogReactivateSignatureRequest={
            this.toggleDialogReactivateSignatureRequest
          }
          onReactivateSignatureRequest={this.onReactivateSignatureRequest}
          warningUserDontHaveIne={this.warningUserDontHaveIne}
          handleWarning={this.handleWarning}
          onHandleGeneralChange={this.onHandleGeneralChange}
          onHandleShowPassword={this.onHandleShowPassword}
          setSignatures={(signatures) =>
            this.setState({ allSignatures: signatures })
          }
          onErrorTimeStamp={this.onErrorTimeStamp}
        />
      )
    )
  }
}

function SignatureRequestDetailActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <SignatureRequestDetailAction
      {...props}
      t={t}
      setShowError={setShowError}
    />
  );
}

export { SignatureRequestDetailActionContainer as default };
